const previousPage = document.referrer;
const bannerBackButtonWrapper = document.querySelector('.page-header-banner .page-header-banner__back-button-wrapper');
let bannerFirstBackDestination, bannerBackDestinations, backButton, needsFallBack = true
if(bannerBackButtonWrapper){
  bannerBackDestinations = bannerBackButtonWrapper.querySelectorAll('.fall-back-url span')
  bannerFirstBackDestination = bannerBackButtonWrapper.querySelector('.fall-back-url span.first-destination')
  backButton = bannerBackButtonWrapper.querySelector('.back-link')
  if(bannerBackDestinations.length>0){
    for (let i = 0; i < bannerBackDestinations.length; i++) {
      let fallBackUrl = bannerBackDestinations[i].innerText;
      if (previousPage.includes(fallBackUrl)){
        needsFallBack = false
        break
      }
    }
  }
  if(needsFallBack){
    backButton.removeAttribute('onClick');
    backButton.setAttribute('href', bannerFirstBackDestination.innerText)
  }
}

